window.NOTIFFICATIONS = {
    layers: {
        server_no_connection: {
            layer: $('.notification.server'),
            cross: $('.notification.server .cross'),
            timerID: false
        },

        sms: {
            send_error: {
                layer: $('.notification.sms_send_error'),
                cross: $('.notification.sms_send_error .cross'),
                timerID: false
            }
        },

        recovery: {
            success: {
                layer: $('.notification.email_recovery_success'),
                cross: $('.notification.email_recovery_success .cross'),
                timerID: false
            }
        },

        general_info_success: {
            layer: $('.notification.general_info_success'),
            cross: $('.notification.general_info_success .cross'),
            timerID: false
        },

        change_password_success: {
            layer: $('.notification.change_password_success'),
            cross: $('.notification.change_password_success .cross'),
            timerID: false
        },

        bank_card_delete_success: {
            layer: $('.notification.bank_card_delete_success'),
            cross: $('.notification.bank_card_delete_success .cross'),
            timerID: false
        },

        default_bank_card: {
            layer: $('.notification.default_bank_card'),
            cross: $('.notification.default_bank_card .cross'),
            timerID: false
        },

        user: {
            bunned: {
                layer: $('.notification.user_bunned'),
                    cross: $('.notification.user_bunned .cross'),
                    timerID: false
            }
        },

        success_saved: {
            layer: $('.notification.success_saved'),
            cross: $('.notification.success_saved .cross'),
            timerID: false
        },

        error_saved: {
            layer: $('.notification.error_saved'),
            cross: $('.notification.error_saved .cross'),
            timerID: false
        },

        success_delete: {
            layer: $('.notification.success_delete'),
            cross: $('.notification.success_delete .cross'),
            timerID: false
        },

        error_delete: {
            layer: $('.notification.error_delete'),
            cross: $('.notification.error_delete .cross'),
            timerID: false
        },

        send_to_charger_success: {
            layer: $('.notification.send_to_charger_success'),
            cross: $('.notification.send_to_charger_success .cross'),
            timerID: false
        },

        send_to_charger_error: {
            layer: $('.notification.send_to_charger_error'),
            cross: $('.notification.send_to_charger_error .cross'),
            timerID: false
        },

        connector_book_success: {
            layer: $('.notification.connector_book_success'),
            cross: $('.notification.connector_book_success .cross'),
            timerID: false
        },

        connector_book_error: {
            layer: $('.notification.connector_book_error'),
            cross: $('.notification.connector_book_error .cross'),
            timerID: false
        },

        low_balance: {
            layer: $('.notification.low_balance'),
            cross: $('.notification.low_balance .cross'),
            timerID: false
        },

        need_to_auth: {
            layer: $('.notification.need_to_auth'),
            cross: $('.notification.need_to_auth .cross'),
            timerID: false
        },

        review_success: {
            layer: $('.notification.review_success'),
            cross: $('.notification.review_success .cross'),
            timerID: false
        },

        review_error: {
            layer: $('.notification.review_error'),
            cross: $('.notification.review_error .cross'),
            timerID: false
        },

        wrong_password: {
            layer: $('.notification.wrong_password'),
            cross: $('.notification.wrong_password .cross'),
            timerID: false
        },

        referral_link_copy: {
            layer: $('.notification.referral_link_copy_success'),
            cross: $('.notification.referral_link_copy_success .cross'),
            timerID: false
        }
    },

    init: async () => {
        window.NOTIFFICATIONS.layers.server_no_connection.cross.click(function () {
            if(window.NOTIFFICATIONS.layers.server_no_connection.layer.hasClass('active')) {
                window.NOTIFFICATIONS.layers.server_no_connection.layer.removeClass('active');
            }
        });
        window.NOTIFFICATIONS.layers.sms.send_error.cross.click(function () {
            if(window.NOTIFFICATIONS.layers.sms.send_error.layer.hasClass('active')) {
                window.NOTIFFICATIONS.layers.sms.send_error.layer.removeClass('active');
            }
        });
        window.NOTIFFICATIONS.layers.recovery.success.cross.click(function () {
            if(window.NOTIFFICATIONS.layers.recovery.success.layer.hasClass('active')) {
                window.NOTIFFICATIONS.layers.recovery.success.layer.removeClass('active');
            }
        });
        window.NOTIFFICATIONS.layers.general_info_success.cross.click(function () {
            if(window.NOTIFFICATIONS.layers.general_info_success.layer.hasClass('active')) {
                window.NOTIFFICATIONS.layers.general_info_success.layer.removeClass('active');
            }
        });
        window.NOTIFFICATIONS.layers.change_password_success.cross.click(function () {
            if(window.NOTIFFICATIONS.layers.change_password_success.layer.hasClass('active')) {
                window.NOTIFFICATIONS.layers.change_password_success.layer.removeClass('active');
            }
        });
        window.NOTIFFICATIONS.layers.bank_card_delete_success.cross.click(function () {
            if(window.NOTIFFICATIONS.layers.bank_card_delete_success.layer.hasClass('active')) {
                window.NOTIFFICATIONS.layers.bank_card_delete_success.layer.removeClass('active');
            }
        });
        window.NOTIFFICATIONS.layers.default_bank_card.cross.click(function () {
            if(window.NOTIFFICATIONS.layers.default_bank_card.layer.hasClass('active')) {
                window.NOTIFFICATIONS.layers.default_bank_card.layer.removeClass('active');
            }
        });
        window.NOTIFFICATIONS.layers.success_saved.cross.click(function () {
            if(window.NOTIFFICATIONS.layers.success_saved.layer.hasClass('active')) {
                window.NOTIFFICATIONS.layers.success_saved.layer.removeClass('active');
            }
        });
        window.NOTIFFICATIONS.layers.error_saved.cross.click(function () {
            if(window.NOTIFFICATIONS.layers.error_saved.layer.hasClass('active')) {
                window.NOTIFFICATIONS.layers.error_saved.layer.removeClass('active');
            }
        });
        window.NOTIFFICATIONS.layers.success_delete.cross.click(function () {
            if(window.NOTIFFICATIONS.layers.success_delete.layer.hasClass('active')) {
                window.NOTIFFICATIONS.layers.success_delete.layer.removeClass('active');
            }
        });
        window.NOTIFFICATIONS.layers.error_delete.cross.click(function () {
            if(window.NOTIFFICATIONS.layers.error_delete.layer.hasClass('active')) {
                window.NOTIFFICATIONS.layers.error_delete.layer.removeClass('active');
            }
        });
        window.NOTIFFICATIONS.layers.send_to_charger_success.cross.click(function () {
            if(window.NOTIFFICATIONS.layers.send_to_charger_success.layer.hasClass('active')) {
                window.NOTIFFICATIONS.layers.send_to_charger_success.layer.removeClass('active');
            }
        });
        window.NOTIFFICATIONS.layers.send_to_charger_error.cross.click(function () {
            if(window.NOTIFFICATIONS.layers.send_to_charger_error.layer.hasClass('active')) {
                window.NOTIFFICATIONS.layers.send_to_charger_error.layer.removeClass('active');
            }
        });
        window.NOTIFFICATIONS.layers.connector_book_success.cross.click(function () {
            if(window.NOTIFFICATIONS.layers.connector_book_success.layer.hasClass('active')) {
                window.NOTIFFICATIONS.layers.connector_book_success.layer.removeClass('active');
            }
        });
        window.NOTIFFICATIONS.layers.connector_book_error.cross.click(function () {
            if(window.NOTIFFICATIONS.layers.connector_book_error.layer.hasClass('active')) {
                window.NOTIFFICATIONS.layers.connector_book_error.layer.removeClass('active');
            }
        });
        window.NOTIFFICATIONS.layers.low_balance.cross.click(function () {
            if(window.NOTIFFICATIONS.layers.low_balance.layer.hasClass('active')) {
                window.NOTIFFICATIONS.layers.low_balance.layer.removeClass('active');
            }
        });
        window.NOTIFFICATIONS.layers.need_to_auth.cross.click(function () {
            if(window.NOTIFFICATIONS.layers.need_to_auth.layer.hasClass('active')) {
                window.NOTIFFICATIONS.layers.need_to_auth.layer.removeClass('active');
            }
        });
        window.NOTIFFICATIONS.layers.review_success.cross.click(function () {
            if(window.NOTIFFICATIONS.layers.review_success.layer.hasClass('active')) {
                window.NOTIFFICATIONS.layers.review_success.layer.removeClass('active');
            }
        });
        window.NOTIFFICATIONS.layers.review_error.cross.click(function () {
            if(window.NOTIFFICATIONS.layers.review_error.layer.hasClass('active')) {
                window.NOTIFFICATIONS.layers.review_error.layer.removeClass('active');
            }
        });
        window.NOTIFFICATIONS.layers.wrong_password.cross.click(function () {
            if(window.NOTIFFICATIONS.layers.wrong_password.layer.hasClass('active')) {
                window.NOTIFFICATIONS.layers.wrong_password.layer.removeClass('active');
            }
        });
        window.NOTIFFICATIONS.layers.referral_link_copy.cross.click(function () {
            if(window.NOTIFFICATIONS.layers.referral_link_copy.layer.hasClass('active')) {
                window.NOTIFFICATIONS.layers.referral_link_copy.layer.removeClass('active');
            }
        });

        window.NOTIFFICATIONS.layers.user.bunned.cross.click(function () {
            if(window.NOTIFFICATIONS.layers.user.bunned.layer.hasClass('active')) {
                window.NOTIFFICATIONS.layers.user.bunned.layer.removeClass('active');
            }
        });
    },

    open_server_no_connected: async () => {
        if(!window.NOTIFFICATIONS.layers.server_no_connection.layer.hasClass('active')) {
            window.NOTIFFICATIONS.layers.server_no_connection.layer.addClass('active');
        }
        window.NOTIFFICATIONS.layers.server_no_connection.timerID = setTimeout(function(){
            if(window.NOTIFFICATIONS.layers.server_no_connection.layer.hasClass('active')) {
                window.NOTIFFICATIONS.layers.server_no_connection.cross.click();
            }
        }, 5000);
    },

    close_server_no_connected: async () => {
        if(window.NOTIFFICATIONS.layers.server_no_connection.layer.hasClass('active')) {
            window.NOTIFFICATIONS.layers.server_no_connection.cross.click();
        }
    },

    open_send_sms_error: async () => {
        if(!window.NOTIFFICATIONS.layers.sms.send_error.layer.hasClass('active')) {
            window.NOTIFFICATIONS.layers.sms.send_error.layer.addClass('active');
        }
        window.NOTIFFICATIONS.layers.sms.send_error.timerID = setTimeout(function(){
            if(window.NOTIFFICATIONS.layers.sms.send_error.layer.hasClass('active')) {
                window.NOTIFFICATIONS.layers.sms.send_error.cross.click();
            }
        }, 5000);
    },

    open_recovery_emailsuccess: async () => {
        if(!window.NOTIFFICATIONS.layers.recovery.success.layer.hasClass('active')) {
            window.NOTIFFICATIONS.layers.recovery.success.layer.addClass('active');
        }
        window.NOTIFFICATIONS.layers.recovery.success.timerID = setTimeout(function(){
            if(window.NOTIFFICATIONS.layers.recovery.success.layer.hasClass('active')) {
                window.NOTIFFICATIONS.layers.recovery.success.cross.click();
            }
        }, 5000);
    },

    open_general_info_success: async () => {
        if(!window.NOTIFFICATIONS.layers.general_info_success.layer.hasClass('active')) {
            window.NOTIFFICATIONS.layers.general_info_success.layer.addClass('active');
        }
        window.NOTIFFICATIONS.layers.general_info_success.timerID = setTimeout(function(){
            if(window.NOTIFFICATIONS.layers.general_info_success.layer.hasClass('active')) {
                window.NOTIFFICATIONS.layers.general_info_success.cross.click();
            }
        }, 5000);
    },

    open_change_password_success: async () => {
        if(!window.NOTIFFICATIONS.layers.change_password_success.layer.hasClass('active')) {
            window.NOTIFFICATIONS.layers.change_password_success.layer.addClass('active');
        }
        window.NOTIFFICATIONS.layers.change_password_success.timerID = setTimeout(function(){
            if(window.NOTIFFICATIONS.layers.change_password_success.layer.hasClass('active')) {
                window.NOTIFFICATIONS.layers.change_password_success.cross.click();
            }
        }, 5000);
    },

    open_bank_card_delete_success: async () => {
        if(!window.NOTIFFICATIONS.layers.bank_card_delete_success.layer.hasClass('active')) {
            window.NOTIFFICATIONS.layers.bank_card_delete_success.layer.addClass('active');
        }
        window.NOTIFFICATIONS.layers.bank_card_delete_success.timerID = setTimeout(function(){
            if(window.NOTIFFICATIONS.layers.bank_card_delete_success.layer.hasClass('active')) {
                window.NOTIFFICATIONS.layers.bank_card_delete_success.cross.click();
            }
        }, 5000);
    },

    open_default_bank_card: async () => {
        if(!window.NOTIFFICATIONS.layers.default_bank_card.layer.hasClass('active')) {
            window.NOTIFFICATIONS.layers.default_bank_card.layer.addClass('active');
        }
        window.NOTIFFICATIONS.layers.default_bank_card.timerID = setTimeout(function(){
            if(window.NOTIFFICATIONS.layers.default_bank_card.layer.hasClass('active')) {
                window.NOTIFFICATIONS.layers.default_bank_card.cross.click();
            }
        }, 5000);
    },

    open_success_saved: async () => {
        if(!window.NOTIFFICATIONS.layers.success_saved.layer.hasClass('active')) {
            window.NOTIFFICATIONS.layers.success_saved.layer.addClass('active');
        }
        window.NOTIFFICATIONS.layers.success_saved.timerID = setTimeout(function(){
            if(window.NOTIFFICATIONS.layers.success_saved.layer.hasClass('active')) {
                window.NOTIFFICATIONS.layers.success_saved.cross.click();
            }
        }, 5000);
    },

    open_error_saved: async () => {
        if(!window.NOTIFFICATIONS.layers.error_saved.layer.hasClass('active')) {
            window.NOTIFFICATIONS.layers.error_saved.layer.addClass('active');
        }
        window.NOTIFFICATIONS.layers.error_saved.timerID = setTimeout(function(){
            if(window.NOTIFFICATIONS.layers.error_saved.layer.hasClass('active')) {
                window.NOTIFFICATIONS.layers.error_saved.cross.click();
            }
        }, 5000);
    },

    open_success_delete: async () => {
        if(!window.NOTIFFICATIONS.layers.success_delete.layer.hasClass('active')) {
            window.NOTIFFICATIONS.layers.success_delete.layer.addClass('active');
        }
        window.NOTIFFICATIONS.layers.success_delete.timerID = setTimeout(function(){
            if(window.NOTIFFICATIONS.layers.success_delete.layer.hasClass('active')) {
                window.NOTIFFICATIONS.layers.success_delete.cross.click();
            }
        }, 5000);
    },

    open_error_delete: async () => {
        if(!window.NOTIFFICATIONS.layers.error_delete.layer.hasClass('active')) {
            window.NOTIFFICATIONS.layers.error_delete.layer.addClass('active');
        }
        window.NOTIFFICATIONS.layers.error_delete.timerID = setTimeout(function(){
            if(window.NOTIFFICATIONS.layers.error_delete.layer.hasClass('active')) {
                window.NOTIFFICATIONS.layers.error_delete.cross.click();
            }
        }, 5000);
    },

    open_send_to_charger_success: async () => {
        if(!window.NOTIFFICATIONS.layers.send_to_charger_success.layer.hasClass('active')) {
            window.NOTIFFICATIONS.layers.send_to_charger_success.layer.addClass('active');
        }
        window.NOTIFFICATIONS.layers.send_to_charger_success.timerID = setTimeout(function(){
            if(window.NOTIFFICATIONS.layers.send_to_charger_success.layer.hasClass('active')) {
                window.NOTIFFICATIONS.layers.send_to_charger_success.cross.click();
            }
        }, 5000);
    },

    open_send_to_charger_error: async () => {
        if(!window.NOTIFFICATIONS.layers.send_to_charger_error.layer.hasClass('active')) {
            window.NOTIFFICATIONS.layers.send_to_charger_error.layer.addClass('active');
        }
        window.NOTIFFICATIONS.layers.send_to_charger_error.timerID = setTimeout(function(){
            if(window.NOTIFFICATIONS.layers.send_to_charger_error.layer.hasClass('active')) {
                window.NOTIFFICATIONS.layers.send_to_charger_error.cross.click();
            }
        }, 5000);
    },

    open_connector_book_success: async () => {
        if(!window.NOTIFFICATIONS.layers.connector_book_success.layer.hasClass('active')) {
            window.NOTIFFICATIONS.layers.connector_book_success.layer.addClass('active');
        }
        window.NOTIFFICATIONS.layers.connector_book_success.timerID = setTimeout(function(){
            if(window.NOTIFFICATIONS.layers.connector_book_success.layer.hasClass('active')) {
                window.NOTIFFICATIONS.layers.connector_book_success.cross.click();
            }
        }, 5000);
    },

    open_connector_book_error: async () => {
        if(!window.NOTIFFICATIONS.layers.connector_book_error.layer.hasClass('active')) {
            window.NOTIFFICATIONS.layers.connector_book_error.layer.addClass('active');
        }
        window.NOTIFFICATIONS.layers.connector_book_error.timerID = setTimeout(function(){
            if(window.NOTIFFICATIONS.layers.connector_book_error.layer.hasClass('active')) {
                window.NOTIFFICATIONS.layers.connector_book_error.cross.click();
            }
        }, 5000);
    },

    open_low_balance: async () => {
        if(!window.NOTIFFICATIONS.layers.low_balance.layer.hasClass('active')) {
            window.NOTIFFICATIONS.layers.low_balance.layer.addClass('active');
        }
        window.NOTIFFICATIONS.layers.low_balance.timerID = setTimeout(function(){
            if(window.NOTIFFICATIONS.layers.low_balance.layer.hasClass('active')) {
                window.NOTIFFICATIONS.layers.low_balance.cross.click();
            }
        }, 5000);
    },

    open_need_to_auth: async () => {
        if(!window.NOTIFFICATIONS.layers.need_to_auth.layer.hasClass('active')) {
            window.NOTIFFICATIONS.layers.need_to_auth.layer.addClass('active');
        }
        window.NOTIFFICATIONS.layers.need_to_auth.timerID = setTimeout(function(){
            if(window.NOTIFFICATIONS.layers.need_to_auth.layer.hasClass('active')) {
                window.NOTIFFICATIONS.layers.need_to_auth.cross.click();
            }
        }, 5000);
    },

    open_review_error: async () => {
        if(!window.NOTIFFICATIONS.layers.review_error.layer.hasClass('active')) {
            window.NOTIFFICATIONS.layers.review_error.layer.addClass('active');
        }
        window.NOTIFFICATIONS.layers.review_error.timerID = setTimeout(function(){
            if(window.NOTIFFICATIONS.layers.review_error.layer.hasClass('active')) {
                window.NOTIFFICATIONS.layers.review_error.cross.click();
            }
        }, 5000);
    },

    open_review_success: async () => {
        if(!window.NOTIFFICATIONS.layers.review_success.layer.hasClass('active')) {
            window.NOTIFFICATIONS.layers.review_success.layer.addClass('active');
        }
        window.NOTIFFICATIONS.layers.review_success.timerID = setTimeout(function(){
            if(window.NOTIFFICATIONS.layers.review_success.layer.hasClass('active')) {
                window.NOTIFFICATIONS.layers.review_success.cross.click();
            }
        }, 5000);
    },

    open_user_bunned: async () => {
        if(!window.NOTIFFICATIONS.layers.user.bunned.layer.hasClass('active')) {
            window.NOTIFFICATIONS.layers.user.bunned.layer.addClass('active');
        }
        window.NOTIFFICATIONS.layers.user.bunned.timerID = setTimeout(function(){
            if(window.NOTIFFICATIONS.layers.user.bunned.layer.hasClass('active')) {
                window.NOTIFFICATIONS.layers.user.bunned.cross.click();
            }
        }, 5000);
    },

    open_wrong_password: async () => {
        if(!window.NOTIFFICATIONS.layers.wrong_password.layer.hasClass('active')) {
            window.NOTIFFICATIONS.layers.wrong_password.layer.addClass('active');
        }
        window.NOTIFFICATIONS.layers.wrong_password.timerID = setTimeout(function(){
            if(window.NOTIFFICATIONS.layers.wrong_password.layer.hasClass('active')) {
                window.NOTIFFICATIONS.layers.wrong_password.cross.click();
            }
        }, 5000);
    },

    open_referall_link_copy_success: async () => {
        if(!window.NOTIFFICATIONS.layers.referral_link_copy.layer.hasClass('active')) {
            window.NOTIFFICATIONS.layers.referral_link_copy.layer.addClass('active');
        }
        window.NOTIFFICATIONS.layers.referral_link_copy.timerID = setTimeout(function(){
            if(window.NOTIFFICATIONS.layers.referral_link_copy.layer.hasClass('active')) {
                window.NOTIFFICATIONS.layers.referral_link_copy.cross.click();
            }
        }, 5000);
    }
};
window.NOTIFFICATIONS.init();
